window.updateFavorite = async (element) => {
    if (!window.auth) {
        window.location.href = window.subscription_page;
        return;
    }

    const self = $(element);
    const sub = self.data('sub');

    if (sub) {
        window.location.href = window.subscription_page;
        return;
    }

    const request = {
        item_id: self.data('id'),
        item_alias: self.data('alias'),
    };

    try {
        const response = await axios.post('/favorite/toggle', request);

        setFavorite(request.item_id, request.item_alias, response.data.data.is_favorite);
    } catch (e) {
        console.error(e);
    }
}

function setFavorite(id, alias, status) {
    const favoriteEl = $(`[data-alias="${alias}"][data-id="${id}"]`).removeClass('active');

    if (status) {
        favoriteEl.addClass('active');
    }
}

function setActiveFavorites(favorites) {
    for (const favorite of favorites) {
        setFavorite(favorite.id, favorite.alias, true);
    }
}

setActiveFavorites(window.favorites || []);

$(document).on('player.loaded', () => {
    setActiveFavorites(window.favorites || []);
});
